import {gql} from '@apollo/client';

export default gql`
  mutation contactedContact($input: ContactedContactInput!) {
    authed {
      success
    }
    contactedContact(input: $input) {
      success
    }
  }
`;
